import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getSpecialist, getSpecialistSlots } from '../api/client';
import Footer from '../components/Footer';

export default function SpecialistPage() {
  const { clinicId, serviceId, specId } = useParams();
  const navigate = useNavigate();
  const [specialist, setSpecialist] = useState(null);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const today = new Date().toISOString().split('T')[0];
        const [specialistResponse, slotsResponse] = await Promise.all([
          getSpecialist(clinicId, specId),
          getSpecialistSlots(specId, today)
        ]);
        
        setSpecialist(specialistResponse.specialist);
        setSlots(slotsResponse.availableSlots[today] || []);
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки данных специалиста:', err);
        setError('Не удалось загрузить данные специалиста. Пожалуйста, попробуйте позже.');
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [clinicId, specId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500 text-center">
          <p className="text-xl font-semibold mb-2">Ошибка</p>
          <p>{error}</p>
          <button 
            onClick={() => navigate(`/${clinicId}/${serviceId}`)}
            className="mt-4 px-4 py-2 bg-secondary text-white rounded-md hover:bg-secondary/90 transition"
          >
            Вернуться к списку специалистов
          </button>
        </div>
      </div>
    );
  }

  if (!specialist) {
    return (
      <div className="text-center p-8 text-gray-500">
        Специалист не найден
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 text-gray-800">
      <header className="bg-white shadow p-4 sticky top-0 z-10">
        <div className="flex items-center gap-4 max-w-xl mx-auto relative">
          <Link
            to={`/${clinicId}/${serviceId}`}
            className="absolute left-0 text-gray-600 hover:bg-gray-100 rounded-full w-10 h-10 flex items-center justify-center transition"
          >
            ←
          </Link>
          <h1 className="text-center flex-grow text-lg font-semibold">Запись на приём</h1>
        </div>
      </header>

      <main className="max-w-xl mx-auto px-4 py-6 pb-24">
        <div className="bg-white rounded-xl shadow p-6 mb-6">
          <div className="flex gap-4">
            <img
              src={specialist.photo}
              alt={specialist.name}
              className="w-20 h-20 rounded-full object-cover bg-primary/10 border"
            />
            <div>
              <div className="text-lg font-semibold">{specialist.name}</div>
              <div className="text-sm text-gray-500">{specialist.specialization}</div>
              {specialist.specializations && specialist.specializations.length > 0 && (
                <div className="flex gap-2 flex-wrap mt-2">
                  {specialist.specializations.map((spec, idx) => (
                    <span key={idx} className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full">
                      {spec}
                    </span>
                  ))}
                </div>
              )}
              <div className="text-sm text-gray-500 mt-2">
                ⭐ {typeof specialist.avarage_rating === 'number' ? specialist.avarage_rating.toFixed(1) : '5.0'} | 
                {specialist.experience && ` Стаж: ${specialist.experience} лет`}
              </div>
            </div>
          </div>

          {specialist.description && (
            <div className="mt-6">
              <h2 className="text-sm font-semibold mb-2">О специалисте</h2>
              <p className="text-sm text-gray-600 leading-relaxed">{specialist.description}</p>
            </div>
          )}
        </div>

        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-sm font-semibold">Доступное время сегодня</h2>
            <div className="text-sm text-gray-500">
              {slots.length} {slots.length === 1 ? 'слот' : slots.length < 5 ? 'слота' : 'слотов'}
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {slots.length > 0 ? (
              slots.map((slot, idx) => (
                <Link
                  to={`/booking/${clinicId}/${serviceId}/${specId}/confirm?slot=${encodeURIComponent(JSON.stringify(slot))}`}
                  key={idx}
                  className="text-center text-sm py-2 px-4 bg-secondary/10 text-secondary rounded-lg hover:bg-secondary/20 transition"
                >
                  {new Date(slot.start_time).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                  })}
                </Link>
              ))
            ) : (
              <div className="col-span-full text-center text-sm text-gray-500">Нет доступных слотов</div>
            )}
          </div>

          <Link
            to={`/${clinicId}/${serviceId}/${specId}/book`}
            className="block text-center mt-6 w-full py-3 bg-secondary text-white font-semibold rounded-lg hover:bg-secondary/90 transition"
          >
            Выбрать другой день
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
